import Telpas from './Telpas.component';

export default Telpas;
